<template>
    <div id="main-header">
        <!--nav-->
        <nav class="navbar navbar-default no-margin app-sidebar-nav">
            <header class="col-12">
                <div class="logo-section col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <a href="javascript:void(0)" v-on:click="dashboardPageRedirect()">
                        <img src="/static/images/vvg-logo.png" alt="VVG Logo"> 
                    </a>
                </div>
                <div class="search-section col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <div class="form-group has-search">
                        <form action="" autocomplete="on" v-on:submit.prevent="universalSearchAPI()">
                            <input v-model="universalSearchText" id="customerGlobalSearch" type="text" class="form-control" placeholder="Search Part : (Sample ATR TR46-41002)">
                            <span class="fa fa-search form-control-feedback"></span>
                        </form>
                    </div>
                </div>
                <div class="action-btn-section col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <template v-if="isUserLogin">
                        <!-- <div class="customer-portal-dropdown"> -->
                            <v-select v-model="customerId"
                                name="customerId"
                                id="customerId"
                                label="text"
                                :filterable="true"
                                :options="customerArr"
                                :clearable=false
                                @input="onChnageCustomer()"
                                placeholder="Select Customer"
                                style="width: 265px;">
                            </v-select>
                        <!-- </div> -->
                    </template>
                    <label class="dropdown">
                        <div class="dd-button">
                            <span>  <img src="/static/images/avtar-img.png" alt="User Account"> </span> My Account
                        </div>
                        <input type="checkbox" class="dd-input" id="test">
                        <ul class="dd-menu">
                            <li>
                                <a class="dropdown-item" href="javascript:void(0)" v-on:click.prevent="logout()">Logout</a>
                            </li>
                        </ul>
                    </label>
                    <div class="orders-btn">
                        <a href="javascript:void(0)" v-on:click.prevent="goToOrderListWithFilters()">
                            <span> <img src="/static/images/order-img.png" alt="Order"> </span> order
                        </a>
                    </div>
                    <template v-if="!isUserLogin">
                        <div class="shopping-cart-img">
                            <a class="cart-img" href="javascript:void(0)" v-on:click.prevent="useParts()"> <img src="/static/images/cart-img.png" alt="Shopping Cart"> </a>
                        </div>
                        <div class="shopping-cart-img">
                            <a class="cart-img" href="javascript:void(0)" v-on:click.prevent="notificationClick()">
                                <template v-if="isNotificationEnable">
                                    <img src="/static/images/d_notification.png" alt="Disable Notification Bell" title="Disable Notification">
                                </template>
                                <template v-else>
                                    <img src="/static/images/e_notification.png" alt="Enable Notification Bell" title="Enable Notification">
                                </template>
                            </a>
                        </div>
                    </template>
                </div>
            </header>
            <a href="javascript:void(0)" id="scroll" title="Scroll to Top" style="display: none;">Top<span></span></a>
        </nav>
    </div>
    <!--nav-->
</template>

<script>

    import Vue from 'vue';
    import EventBus from '.././event-bus';
    import {HTTP} from '../../http-common';
    import vSelect from 'vue-select';
    import { commonMixins } from "../../mixins/commonMixins";
    var self;

    export default {
        name: 'Header',
        components: {
            'v-select': vSelect,
        },
        mixins: [commonMixins],
        data() {
            return {
                customerId: "",
                customerArr: [],
                username: '',
                firstName: '',
                lastName: '',
                iconLetters: '',
                universalSearchText: '',
                isNotificationEnable: false,
                isUserLogin: false
            }
        },

        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self = this;
            if(localStorage.getItem("is-notification-enabled") == 'true') {
                self.isNotificationEnable = true;
            }
            if(localStorage.getItem("login_role") == 'user') {
                self.isUserLogin = true;
                self.getAllCustomer();
            }
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    $('#scroll').fadeIn();
                } else {
                    $('#scroll').fadeOut();
                }
            });
            $('#scroll').click(function () {
                $("html, body").animate({
                    scrollTop: 0
                }, 600);
                return false;
            });
            if(localStorage.getItem("login_role") == 'customer') {
                var customerObj = localStorage.getItem("customer_obj");
                if (customerObj != null) {
                    var customerJson = JSON.parse(customerObj);
                    /* console.log(customerJson['id']);
                    console.log(customerJson['parent_customer_id']); */
                    if(customerJson['parent_customer_id'] != 0) {
                        self.getCustomerDetailById(customerJson['id']);
                    }
                }
            }
        },
        methods: {
            getAllCustomer: function() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                HTTP.get('/customer/all/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.customerArr = response.data.content;
                            if(localStorage.getItem("customer_id")) {
                                for(var index = 0; index< self.customerArr.length; index++) {
                                    if(self.customerArr[index].value == localStorage.getItem("customer_id")) {
                                        self.customerId = {text: self.customerArr[index].text, value: localStorage.getItem("customer_id")};
                                    }
                                }
                            }
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            onChnageCustomer : function () {
                localStorage.setItem("customer_id", self.customerId.value);
                EventBus.$emit('change-customer-dropdown-value', true);
            },
            notificationClick: function() {
                self.isNotificationEnable = false;
                if(localStorage.getItem("is-notification-enabled") == 'false') {
                    /* navigator.permissions.query({name: 'push'}).then(function(status) {
                        // Initial permission status is `status.state`
                        if(status.state === 'granted') {
                            localStorage.setItem("is-notification-enabled", true);
                        } else {
                            location.reload(true);
                        }
                    }); */
                    if ('Notification' in window) {
                        Notification.requestPermission().then(function(status) {
                            if(status == 'granted') {
                                self.isNotificationEnable = true;
                                localStorage.setItem("is-notification-enabled", true);
                            } else {
                                // location.reload(true);
                                self.isNotificationEnable = false;
                                localStorage.setItem("is-notification-enabled", false);
                                self.$swal('', 'Please Enable Notification in browser settings', 'info');
                            }
                        });
                    }
                } else {
                    localStorage.setItem("is-notification-enabled", false);
                }
            },
            useParts: function() {
              	self.$router.push("/customer/use-parts?isEdit=No&barcodeScan=Yes");
            },
            dashboardPageRedirect: function() {
                self.$router.push({name:'CustomerDashboard'});
            },
            logout: function () {
                let current_build = window.localStorage.getItem("build_version");
                localStorage.clear();
                localStorage.setItem("build_version", current_build);
                self.$router.push("/");
            },
            goToOrderListWithFilters: function() {
                var path = window.location.pathname;
                var segments = path.split("/");
                if(segments[2] === 'order-history' && localStorage.getItem("usingDateRangeFilters") != 'yes') {
                    localStorage.setItem("usingDateRangeFilters", 'yes');
                    window.location.href = "/customer/order-history";
                } else {
                    if(localStorage.getItem("usingDateRangeFilters") != 'yes') {
                        localStorage.setItem("usingDateRangeFilters", 'yes');
                        self.$router.push({name:'CustomerOrderHistory'});
                    }
                }
            },
            universalSearchAPI: function() {
                if(localStorage.getItem("login_role") == 'user' && !localStorage.getItem("customer_id")) {
                    self.showSAlert("Please Select Customer First", 'info', false); 
                    return false; 
                }
                var strText = JSON.stringify(self.universalSearchText);
                if(strText != "") {
                    localStorage.removeItem("universalSearch");
                    var customerId = 0;
                    if(localStorage.getItem("login_role") == 'user') {
                        customerId = localStorage.getItem("customer_id");
                    } else {
                        customerId = JSON.parse(localStorage.getItem('customer_obj')).id
                    }
                    var config = {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("api_token")
                        },
                        params : {
                            strSearch: self.universalSearchText,
                            customer_id: customerId
                        }
                    };
                    HTTP.get('/customer/universal-search', config)
                        .then(function (response) {
                            if (response.status == '200') {
                                var search = self.universalSearchText;
                                self.universalSearchText = "";
                                // self.$router.push({name:'CustomerUseParts', params:{id:response.data.content.part_id, name: response.data.content.strip_part_no}});
                                var path = window.location.pathname;
                                var segments = path.split("/");
                                if(segments[2] === 'list-inventory') {
                                    localStorage.setItem("universalSearch", search);
                                    window.location.href = "/customer/list-inventory";
                                } else {
                                    self.$router.push({name:'ListInventory', params:{name: search}});
                                }
                            } else {
                                if (response.status == '201') {
                                    self.$swal('', 'This part is not currently in your consigned inventory, so please call Velocity Parts to order', 'info');
                                }
                            }
                        })
                        .catch(function (err) {
                            self.catchHandler(err);
                        })
                }
            }
        },
    }
    EventBus.$on('login-customer-info', function (isLogin, user_name, first_name) {
        if(typeof (self) != "undefined"){
            self.username = user_name;
            if(first_name != null) {
                self.firstName = first_name;
            } else {
                self.firstName = "NA";
            }
            //First Two Characters in Upper Case of Username in iconLetters
            self.iconLetters = self.username.substring(0,2).toUpperCase();
        }
    });
    EventBus.$on("notification-allow", function(data) {
        if (typeof self != "undefined") {
            console.log(data);
            self.isNotificationEnable = false;
            if(data) {
                self.isNotificationEnable = true;
            }
        }
    });
</script>
<style>
    .action-btn-section .dropdown-toggle {
        height: 43px;
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/partials/CustomerHeader.vue